export default __webpack_public_path__ + "static/media/title_ko_pc@2x.ab8de009.png";